"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockIAListMontiert = void 0;
const tslib_1 = require("tslib");
// @ts-nocheck
const IAList_1 = require("./IAList");
const mockIaList_json_1 = tslib_1.__importDefault(require("./mockIaList.json"));
// prettier-ignore
exports.mockIAListMontiert = IAList_1.IAList.fromJson(mockIaList_json_1.default).filter(ia => ia.montiert);
//# sourceMappingURL=mockIaList.js.map